const B_1 = [
    {
        title: '添加入围公告',
        path: '/bidding/projectflow/dingbiao/frame-agreement/shortlisted-notice/list'
    }
]
export default{
    path:"shortlisted-notice",
    component:() => import(/*webpackChunkName: 'bidding-projectflow-dingbiao-frame-agreement-shortlisted-notice'*/ '@layout/empty'),
    children:[
        {
            path:"list",
            component:() => import('@views/bidding/views/project-flow/ding/frame-agreement/shortlisted-notice/list'),
            meta: {
                title: '入围公告列表',
                bread: B_1
            },
        },
        {
            path:"form",
            component:() => import('@views/bidding/views/project-flow/ding/frame-agreement/shortlisted-notice/form'),
            meta: {
                title: '添加/修改入围公告',
                bread: B_1
            },
        },
        {
            path:"detail",
            component:() => import('@views/bidding/views/project-flow/ding/frame-agreement/shortlisted-notice/detail'),
            meta: {
                title: '查看入围公告',
                bread: B_1
            },
        },
    ]
}